<template>
    <div class="f7">
        <ul class="navigate" v-if="geo">
            <li>
                <a class="link" :href="glb.appUrl">Real Estate</a>
            </li>
            <li>
                <a class="link" :href="glb.appUrl + geo.statePath">{{geo.stateFullName}}</a>
            </li>
            <template v-if="geo.cityPath">
                <li>
                    <a class="link" :href="glb.appUrl + geo.cityPath">{{geo.city}}</a>
                </li>
                <li>
                    <a class="link" :href="glb.appUrl + 'guide/' + geo.cityPath">Overview</a>
                </li>
            </template>
        </ul>
        <ul class="navigate">
            <li v-if="guide.nextArticle">
                <a class="link" :href="glb.appUrl + guide.nextArticle.url">Next Article</a>
            </li>
            <li v-if="guide.prevArticle">
                <a class="link" :href="glb.appUrl + guide.prevArticle.url">Previous Article</a>
            </li>
        </ul>
    </div>
</template>

<script src="./guide-navigation.js"></script>

<style lang="scss">
@use './guide-navigation.scss' as *;
</style>